export default {
  // --- stock-quantity-meta.tsx ---
  Reason: "Raison",
  "Quantity Added": "Quantité ajoutée",
  "Quantity Removed": "Quantité retirée",
  "Stock Batch": "Lot de stock",
  Date: "Date",
  Actions: "Actions",

  // --- stock-quantity-form.tsx ---
  "Stock Batch ID": "ID du lot de stock",
  "Batch Code": "Code de lot",
  "Expiry Date": "Date d'expiration",

  // --- select-stock-quantity.tsx ---
  "Stock Quantity": "Quantité de stock",
  "Search stock quantity by reason or batch code":
    "Rechercher une quantité de stock par raison ou code de lot",
  "Edit Selection": "Modifier la sélection",
  "No stock quantities found": "Aucune quantité de stock trouvée",

  // --- create-stock-quantity-modal.tsx ---
  "Create a new stock quantity": "Créer une nouvelle quantité de stock",

  // --- edit-stock-quantity-modal.tsx ---
  "Edit Stock Quantity": "Modifier la quantité de stock",

  // --- view-stock-quantity-modal.tsx & view-stock-quantity-block.tsx ---
  "General Information": "Informations générales",
  "Created At": "Créé le",
  "Updated At": "Mis à jour le",

  // --- delete-stock-quantity-modal.tsx ---
  "Do you really want to delete this Stock Quantity?":
    "Voulez-vous vraiment supprimer cette quantité de stock ?",
  "Warning: This action is irreversible and may lead to cascade deletions.":
    "Avertissement : Cette action est irréversible et peut entraîner des suppressions en cascade.",
  Cancel: "Annuler",
  "Confirm Deletion": "Confirmer la suppression",

  // --- stock-quantity-list-block.tsx ---
  "Add stock quantity": "Ajouter une quantité de stock",

  // --- General ---
  Submit: "Soumettre",
};
